var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h-card',_vm._b({attrs:{"color":_vm.color,"title":_vm.title,"text":_vm.text}},'h-card',_vm.$attrs,false),[_c('h-table',_vm._g(_vm._b({attrs:{"infinite":"","hide-top":"","sort-key":_vm.sortKey,"sort-desc":_vm.sortDesc}},'h-table',_vm.$attrs,false),_vm.$listeners))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }